import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getLocalStorageItem, getRefreshToken, popup, setLocalStorageItem } from '../../../utils';
import { BUTTONS, ERROR, LABEL, LOCAL_STORAGE, ROLES } from '../../../constants';
import { setLoaderVisibility, setSessionPopup } from '../../../redux';

const MODAL_OFFSET = 60 * 1000; // 1 minute

export const SessionPopup = () => {
    const sessionPopup = useSelector((state) => state.sessionPopup);
    const dispatch = useDispatch();
    const [isDisabled, setIsDisabled] = useState(false);
    const role = useSelector((state) => state.user.role);
    const userId = getLocalStorageItem(LOCAL_STORAGE.USER_ID);
    let timer = useRef(null);

    //// NOTE: below is align to the current REFRESH_TOKEN expiry time ////
    const refreshExpiry = role === ROLES.USER ? 30 * 60 * 1000 : 180 * 60 * 1000;

    const handleClose = () => {
        dispatch(setSessionPopup(false));
        dispatch(setLoaderVisibility(true));
        setTimeout(() => {
            localStorage.clear();
            dispatch({ type: 'reset/store' });
            window.location.href = '/';
            dispatch(setLoaderVisibility(false));
        }, 1000);
    };

    useEffect(() => {
        const loginAt = parseInt(getLocalStorageItem(LOCAL_STORAGE.LOGIN_AT), 10);
        if (!loginAt || !userId) return;
        const tick = () => {
            const now = Date.now();
            const openModal = now >= loginAt + refreshExpiry - MODAL_OFFSET;

            if (openModal) {
                clearInterval(timer.current);
                dispatch(setSessionPopup(true));
            }
        };

        timer.current = setInterval(tick, 1000);
        tick();

        return () => {
            clearInterval(timer.current);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshExpiry, userId]);

    const handleSession = async () => {
        setIsDisabled(true);
        dispatch(setSessionPopup(true));
        const refresh_token = getLocalStorageItem(LOCAL_STORAGE.REFRESH_TOKEN);
        const user_email = getLocalStorageItem(LOCAL_STORAGE.EMAIL);
        await getRefreshToken({ refresh_token, user_email })
            .then((res) => {
                dispatch(setLoaderVisibility(false));
                if (res?.data) {
                    setLocalStorageItem(LOCAL_STORAGE.LOGIN_AT, Date.now());
                    setIsDisabled(false);
                    dispatch(setSessionPopup(false));
                    setLocalStorageItem(LOCAL_STORAGE.AUTH_TOKEN, res.data.auth_token);
                    window.location.reload();
                } else {
                    handleClose();
                }
            })
            .catch(() => {
                popup('error', ERROR.SESSION_EXPIRED);
                setIsDisabled(false);
                dispatch(setLoaderVisibility(false));
                handleClose();
            });
    };

    return (
        <div>
            {sessionPopup && (
                <div className='popup-overlay'>
                    <div className='popup'>
                        <div className='popup-content'>{LABEL.SESSION_RESTORE}</div>
                        <div className='popup-footer'>
                            <button
                                className='ssc-primary-green-btn w-50 disabled-hover '
                                onClick={handleSession}
                                disabled={isDisabled}
                            >
                                {BUTTONS.YES}
                            </button>
                            <button className='ssc-secondary-white-btn w-50' onClick={handleClose}>
                                {BUTTONS.NO}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
